// extracted by mini-css-extract-plugin
export var border = "_5f-b";
export var circle = "_5f-3";
export var circleInner = "_5f-5";
export var disabled = "_5f-1";
export var focused = "_5f-a";
export var md = "_5f-8";
export var radioButton = "_5f-0";
export var radioInput = "_5f-2";
export var selected = "_5f-9";
export var sm = "_5f-7";
export var text = "_5f-4";
export var xs = "_5f-6";